<div class="advisors-container">
  <div class="header-content">
    <svg xmlns="http://www.w3.org/2000/svg" width="15.6" height="15.598" viewBox="0 0 15.6 15.598"
      (click)="closeDialog()">
      <path
        d="M23.137,8.2a1.13,1.13,0,0,0-1.6,0l-5.866,5.866L9.8,8.2A1.131,1.131,0,0,0,8.2,9.8l5.866,5.866L8.2,21.537a1.131,1.131,0,0,0,1.6,1.6l5.863-5.863,5.866,5.866a1.131,1.131,0,1,0,1.6-1.6l-5.87-5.87L23.137,9.8A1.135,1.135,0,0,0,23.137,8.2Z"
        transform="translate(-7.873 -7.872)" />
    </svg>
  </div>
  <div class="content-advisor">
    <div *ngFor="let advisor of advisors">
      <p class="font-omicron-bold color-black text-size-1 pb-2"
        *ngIf="advisor.line?.toUpperCase() !== typeListProduct.Omigenomics.toUpperCase()">Tu asesor es</p>
      <p class="font-omicron-bold color-black text-size-1 pb-2"
        *ngIf="advisor.line?.toUpperCase() === typeListProduct.Omigenomics.toUpperCase()">Tu asesor Omigenomics es</p>
      <div>
        <div class="profile-image">
          <div class="image" *ngIf="
              advisor.profilePictureUrl === '' ||
              advisor.profilePictureUrl === undefined ||
              advisor.profilePictureUrl === null
            ">
            <p class="text-size-1">{{ advisor.initials }}</p>
          </div>
          <img [src]="advisor.profilePictureUrl" alt="profile image" *ngIf="
              advisor.profilePictureUrl !== '' &&
              advisor.profilePictureUrl !== undefined &&
              advisor.profilePictureUrl !== null
            " />
          <p class="color-omicron font-omicron-bold text-size-1">
            {{ advisor.name }} {{ advisor.middleName }} {{ advisor.lastName }}
          </p>
        </div>
      </div>
      <div class="advisor-footer">
        <p class="subtitle text-size-2">{{ advisor.email }}</p>
        <div class="phone-info">
          <img src="assets/icons/whatapp-green.svg" alt="whatssapp icon" />
          <p class="subtitle text-size-2">Cel: {{ advisor.cellPhone }}</p>
        </div>
      </div>
    </div>
  </div>
</div>